import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    auth: {
      sign_in: {
        title: 'TITLE',
        email: 'EMAIL',
        password: 'PASSWORD',
        password_new: 'PASSWORD_NEW',
        submit: 'SUBMIT',
        two_factor_auth_description: 'TWO_FACTOR_DESCRIPTION',
        mfa_code: 'MFA_CODE',
      },
    },
  }));
}
